import { render } from "./PersonaContactoForm.vue?vue&type=template&id=4a6960c8&scoped=true"
import script from "./PersonaContactoForm.vue?vue&type=script&lang=js"
export * from "./PersonaContactoForm.vue?vue&type=script&lang=js"

import "./PersonaContactoForm.vue?vue&type=style&index=0&id=4a6960c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6960c8"]])

export default __exports__